import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { darken, hideVisually } from 'polished';
import {breakpoints} from '../../styles/breakpoints';

const RadioButtonWrapper = styled.div`
	flex: 0 0 100%;
	padding: 0 5px 10px;
	${breakpoints.medium`
		flex: 0 0 50%;
	`}
	${breakpoints.large`
		flex: 0 0 33.33%;
		max-width: 33.33%;
	`}
`;

const Label = styled.label`
  background-color: ${p =>
    p.checked ? darken(0.2, p.theme.colors.lightBg) : p.theme.colors.lightBg};
  cursor: pointer;
  display: block;
  padding: 15px 20px;
  transition: background-color 0.5s;

  &:hover {
    background-color: ${p =>
      p.checked
        ? darken(0.2, p.theme.colors.lightBg)
        : darken(0.1, p.theme.colors.lightBg)};
  }
`;

const Input = styled.input`
  ${hideVisually()};
`;

const LabelText = styled.span`
  color: ${p => p.theme.colors.lightFont};
  font-size: 1.125rem;
  font-weight: 500;
  letter-spacing: 0.2px;
  line-height: 1;
`;

const ErrorMessage = styled.div`
  color: ${p => p.theme.colors.error};
  font-size: 0.875rem;
  margin-top: 5px;
`;

export default function RadioButton({
  name,
  label,
  value,
  checked,
  error,
  touched,
  onChange,
  onBlur,
  ...rest
}) {
  return (
	<RadioButtonWrapper>
		<Label checked={checked}>
		<Input
			type="radio"
			name={name}
			value={value}
			checked={checked}
			onChange={onChange}
			onBlur={onBlur}
			{...rest}
		/>

		<LabelText>{label}</LabelText>

		{touched && error && <ErrorMessage>{error}</ErrorMessage>}
		</Label>
	</RadioButtonWrapper>
  );
}

RadioButton.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  error: PropTypes.string,
  touched: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func
};

RadioButton.defaultProps = {
  error: '',
  touched: false,
  onChange: () => {},
  onBlur: () => {}
};
